import {FC} from 'react';

import {Close} from '@mui/icons-material';
import {Box, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';

import Button from 'components/button/Button';
import {useAppSelector} from 'hooks';
import {getHMMHour} from 'utils';

import {StyledBottomSheet} from './styles';
import MapPicture from '../../assets/images/redMapWithPin.png';
import BellPicture from '../../assets/images/redWarningBell.png';

export interface IAfterCutoffProps {
  open: boolean;
  onClose: () => void;
}

export interface IDisabledExpressProps extends IAfterCutoffProps {
  openAddressModal: () => void;
}

export const ExpressUnavailableDrawer: FC<IAfterCutoffProps> = ({open, onClose}) => {
  const {t} = useTranslation();
  const {basket} = useAppSelector((state) => state.basket);
  return (
    <StyledBottomSheet
      open={open}
      anchor="bottom"
      onClose={onClose}
      data-test-id={`express_out_of_working_hours_drawer`}
    >
      <DialogTitle>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={4} alignItems="center" textAlign="center">
          <Box component="img" width={72} height={72} src={BellPicture} />
          <Stack spacing={1}>
            <Typography fontSize={16} fontWeight={700}>
              {t('unifiedBasket.title.expressIsOff')}
            </Typography>
            <Typography fontSize={14} whiteSpace="pre-line">
              <Trans
                i18nKey="unifiedBasket.message.youCanStillPlaceAnOrder"
                values={{time: getHMMHour(basket?.expressStoreInfo?.[0]?.expressDeliveryTimeFrame?.from || 7)}}
              ></Trans>
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" shape="rounded" fullWidth onClick={onClose}>
          {t('label.close')}
        </Button>
      </DialogActions>
    </StyledBottomSheet>
  );
};

export const ExpressDisabledDrawer: FC<IDisabledExpressProps> = ({open, onClose, openAddressModal}) => {
  const {t} = useTranslation();
  return (
    <StyledBottomSheet
      open={open}
      anchor="bottom"
      onClose={onClose}
      data-test-id={`express_disabled_for_location_drawer`}
    >
      <DialogTitle>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={4} alignItems="center" textAlign="center">
          <Box component="img" width={72} height={72} src={MapPicture} />
          <Stack spacing={1}>
            <Typography fontSize={16} fontWeight={700}>
              {t('unifiedBasket.title.expressIsDisabledForThisLocation')}
            </Typography>
            <Typography fontSize={14} whiteSpace="pre-line">
              <Trans i18nKey="unifiedBasket.message.trySwitchLocation" />
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" shape="rounded" fullWidth onClick={openAddressModal}>
          {t('unifiedBasket.label.changeAddress')}
        </Button>
      </DialogActions>
    </StyledBottomSheet>
  );
};
